import { ISelfResponse, IUpdateSelfRequest } from '@/shared/interfaces';
import { atom } from 'jotai/index';

export const selfResponseAtom = atom<ISelfResponse | null>();

export const selfRequestAtom = atom((get) => {
    const response = get(selfResponseAtom);

    if (!response) return null;

    return {
        Name:
            response.Me.User.FullName === 'Pseudonym'
                ? ''
                : (response.Me.User.FullName ?? ''),
        Email: response.Me.Email ?? '',
        CPR: response.Me.CprValidated ? (response.Me.CPR ?? '') : '',
        Mobile: response.Me.MobilePhone ?? '',
    } as IUpdateSelfRequest;
});
